import React from "react";
import brandLogo from "../../../Assets/Images/brand-logo.png";
import "../Sidebar/Sidebar.scss";
import DashBoardIteams from "../../SidebarItems/DashBoardIteams";
import ProductsItems from "../../SidebarItems/ProductsItems";
import CouponItems from "../../SidebarItems/CouponItems";
import ShippingItems from "../../SidebarItems/ShippingItems"
import MasterItems from "../../SidebarItems/MasterItems"

const Sidebar = ({ open }) => {

  return (
    <div className={open ? "sidebar active" : "sidebar"}>
      {/* <div className="sidebar-logo">
        <img src={brandLogo} alt="" className="bg-black"/>
        
         {/* <h3 className="text-white">        Chennai Auction Property */}
         {/* </h3> */}
      {/* </div> */} 
      <h6>Chennai Auction Property</h6>

      <ul className="sidebar-items">
        {/* DashBoard */}
        <DashBoardIteams />
        {/* DashBoard */}
        <CouponItems />

        {/* Products */}
        {/* Products */}

        <ProductsItems />
        {/* Coupon */}
        {/* Coupon */}

        {/* Shipping */}
        {/* <ShippingItems /> */}
        {/* Shipping */}

        {/* Master */}
        <MasterItems />
        {/* Master */}
      </ul>
    </div>
  );
};

export default Sidebar;
